import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden mt-12">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20collection%20displayed%20on%20light%20sage%20green%20silk%20fabric%20backdrop%20with%20golden%20hour%20window%20light%20casting%20warm%20diagonal%20shadows%20luxury%20editorial%20photography%20featuring%20shoes%20handbags%20and%20scarves%20in%20neutral%20tones%20rich%20textures%20sophisticated%20composition&width=1600&height=900&seq=hero-main-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet fashion products collection"
          className="w-full h-full object-cover object-top"
          width={1600}
          height={900}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 font-heading">
          <span className="block tracking-wide uppercase">Hipobuy</span>
          <span className="block italic font-normal text-2xl md:text-4xl lg:text-5xl mt-1">Spreadsheet</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed font-body">
          {t("home.hero.subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer font-body"
          >
            <span>{t("home.hero.cta1")}</span>
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer font-body"
          >
            <span>{t("home.hero.cta2")}</span>
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}